import { useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Key, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminReset() {
  const [params] = useSearchParams();
  const token = useMemo(() => params.get("token") || "", [params]);
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 10) return toast.error("Password must be at least 10 characters.");
    if (pw !== pw2) return toast.error("Passwords do not match.");
    if (!token) return toast.error("Reset link is missing its token.");
    setLoading(true);
    try {
      await api.post("/admin/reset-password", { token, new_password: pw });
      toast.success("Password set. Please sign in.");
      nav("/admin/login");
    } catch { toast.error("Reset link is invalid or expired."); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto mt-20">
      <div className="panel-elev tick-brackets p-8">
        <div className="flex items-center gap-3 mb-6">
          <Key className="w-5 h-5 text-[#00D2FF]" />
          <div>
            <div className="font-tech">Administrator</div>
            <h1 className="text-xl font-semibold text-white">Set new password</h1>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-4" data-testid="admin-reset-form">
          <div>
            <label className="label-cad">New password (min 10 chars)</label>
            <input className="input-cad" type="password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="admin-reset-password" autoComplete="new-password" required />
          </div>
          <div>
            <label className="label-cad">Confirm password</label>
            <input className="input-cad" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="admin-reset-password-confirm" autoComplete="new-password" required />
          </div>
          <button className="btn-primary w-full justify-center" disabled={loading} data-testid="admin-reset-submit">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Set password"}
          </button>
        </form>
      </div>
    </div>
  );
}
